import { createContext, useContext } from "react";

// Same key lt-components' useThemeMode uses. Different origin, so nothing is
// actually shared with the host — this is naming consistency only.
export const STORAGE_KEY = "lt-color-mode";

// "auto" follows the OS. Stored as the raw pick; only the resolved value ever
// reaches data-color-mode.
export const MODES = ["light", "dark", "auto"];

export function getSystemPreference() {
  if (typeof window === "undefined") return "light";
  return window.matchMedia?.("(prefers-color-scheme: dark)")?.matches
    ? "dark"
    : "light";
}

export function resolveMode(mode, systemPreference) {
  return mode === "auto" ? systemPreference : mode;
}

// Embedded cross-origin in the common header, where storage access can throw
// outright if the browser blocks third-party storage. Never let that break render.
export function readStoredMode() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (MODES.includes(stored)) return stored;
  } catch (e) {}
  return "auto";
}

export function storeMode(mode) {
  try {
    localStorage.setItem(STORAGE_KEY, mode);
  } catch (e) {}
}

// ?theme is the iframe host's mode and always wins. Embedded runs never touch
// storage at all: the drawer's theme belongs to the host, so a standalone
// visitor's stored pick must not bleed into it, nor the reverse.
export function resolveInitialMode(paramTheme, isIframe) {
  if (paramTheme === "dark" || paramTheme === "light") return paramTheme;
  if (isIframe) return "light";
  return readStoredMode();
}

export const ThemeContext = createContext({
  mode: "light",
  resolvedMode: "light",
  isDark: false,
  toggleMode: () => {},
});

export const useTheme = () => useContext(ThemeContext);
